import React from 'react';
import { AnchorArrow } from 'react-scale/components';
import Image from 'next/image';
import Link from 'next/link';

const AnnouncementBanner = ({ title, label, link, image, alt }) => (
  <div className="text-white bg-black border-b border-neutral-800">
    <div className="container">
      <div className="flex items-center justify-center">
        <p className="items-center gap-4 py-3 text-sm sm:gap-2 hidden md:flex">
          <span className="relative flex items-center shrink-0 w-8 h-8 md:w-6 md:h-6">
            <Image src={image} alt={alt ?? 'icon'} layout="fill" priority />
          </span>
          <span className="lg:whitespace-nowrap">{title}</span>
          <AnchorArrow href={link} text={label} />
        </p>

        <Link href={link} className="flex items-center gap-4 py-3 text-sm sm:gap-2 md:hidden">
          <span className="relative flex items-center shrink-0 w-8 h-8 md:w-6 md:h-6">
            <Image src={image} alt={alt ?? 'icon'} layout="fill" priority />
          </span>
          <span className="lg:whitespace-nowrap">{title}</span>
        </Link>
      </div>
    </div>
  </div>
);

AnnouncementBanner.defaultProps = {
  image: '/static/images/icons/products/synthetic.svg',
  title: 'Announcement title',
  label: 'Learn More',
  link: '/'
};

export default AnnouncementBanner;
